/**
 * SmartRural Sync API
 * API para sincronizar los datos de Smartrural entre la aplciación móvil y el servidor.
 *
 * OpenAPI spec version: 2.0.1
 * Contact: victor@aidiapp.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { CustomElement } from '../model/customElement';
import { CustomElementJoins } from '../model/customElementJoins';
import { CustomEntity } from '../model/customEntity';
import { CustomEntityFull } from '../model/customEntityFull';
import { CustomEntityJoin } from '../model/customEntityJoin';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { CustomType } from '../model/customType';
import { SnapshotLimits } from '../model/snapshotLimits';
import { CustomElementSnapshot } from '../model/customElementSnapshot';


@Injectable()
export class CustomEntityService {

  protected basePath = 'https://api.smartrural.es:8084/v1';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Create a new CustomElement
     *
     * @param id idcustomEntity Id to get
     * @param customelement CustomElement to create
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createcustomelement(id: number, customelement: CustomElement, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<CustomElement>;
    public createcustomelement(id: number, customelement: CustomElement, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomElement>>;
    public createcustomelement(id: number, customelement: CustomElement, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomElement>>;
    public createcustomelement(id: number, customelement: CustomElement, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling createcustomelement.');
        }

        if (customelement === null || customelement === undefined) {
            throw new Error('Required parameter customelement was null or undefined when calling createcustomelement.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CustomElement>(`${this.basePath}/customElement/${encodeURIComponent(String(id))}`,
            customelement,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a new CustomEntity
     *
     * @param customentity CustomEntity to create
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createcustomentity(customentity: CustomEntity, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<CustomEntity>;
    public createcustomentity(customentity: CustomEntity, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomEntity>>;
    public createcustomentity(customentity: CustomEntity, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomEntity>>;
    public createcustomentity(customentity: CustomEntity, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (customentity === null || customentity === undefined) {
            throw new Error('Required parameter customentity was null or undefined when calling createcustomentity.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CustomEntity>(`${this.basePath}/customentity`,
            customentity,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

     /**
     * Create a new CustomEntity for the company
     *
     * @param idcompany Company Id to get customentities from
     * @param customentity CustomEntity to create
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
      public createcustomentityByCompany(idcompany: string, customentity: CustomEntity, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<CustomEntity>;
      public createcustomentityByCompany(idcompany: string, customentity: CustomEntity, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomEntity>>;
      public createcustomentityByCompany(idcompany: string, customentity: CustomEntity, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomEntity>>;
      public createcustomentityByCompany(idcompany: string, customentity: CustomEntity, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

          if (idcompany === null || idcompany === undefined) {
              throw new Error('Required parameter idcompany was null or undefined when calling createcustomentityByCompany.');
          }

          if (customentity === null || customentity === undefined) {
              throw new Error('Required parameter customentity was null or undefined when calling createcustomentityByCompany.');
          }


          let headers = this.defaultHeaders;
          if (authorization !== undefined && authorization !== null) {
              headers = headers.set('Authorization', String(authorization));
          }

          // authentication (authtoken) required
          if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
              headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
          }

          // to determine the Accept header
          let httpHeaderAccepts: string[] = [
              'application/json'
          ];
          const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
          if (httpHeaderAcceptSelected != undefined) {
              headers = headers.set('Accept', httpHeaderAcceptSelected);
          }

          // to determine the Content-Type header
          const consumes: string[] = [
          ];
          const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
          if (httpContentTypeSelected != undefined) {
              headers = headers.set('Content-Type', httpContentTypeSelected);
          }

          return this.httpClient.post<CustomEntity>(`${this.basePath}/customentity/company/${encodeURIComponent(String(idcompany))}`,
              customentity,
              {
                  withCredentials: this.configuration.withCredentials,
                  headers: headers,
                  observe: observe,
                  reportProgress: reportProgress
              }
          );
      }

    /**
     * Get list of customElement
     *
     * @param id idcustomEntity Id to get
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public customElementlist(id: string, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CustomElement>>;
    public customElementlist(id: string, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CustomElement>>>;
    public customElementlist(id: string, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CustomElement>>>;
    public customElementlist(id: string, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling customElementlist.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<CustomElement>>(`${this.basePath}/customElement/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get list of customEntity from company (only for superadmin)
     *
     * @param idcompany Company Id to get customentities from
     * @param authorization Access token in the format Bearer token
     * @param history Get also elements from snapshots
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public customEntitiesByCompany(idcompany: string, authorization?: string, history?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<CustomEntityFull>>;
     public customEntitiesByCompany(idcompany: string, authorization?: string, history?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CustomEntityFull>>>;
     public customEntitiesByCompany(idcompany: string, authorization?: string, history?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CustomEntityFull>>>;
     public customEntitiesByCompany(idcompany: string, authorization?: string, history?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (idcompany === null || idcompany === undefined) {
             throw new Error('Required parameter idcompany was null or undefined when calling customEntitiesByCompany.');
         }



         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (history !== undefined && history !== null) {
             queryParameters = queryParameters.set('history', <any>history);
         }

         let headers = this.defaultHeaders;
         if (authorization !== undefined && authorization !== null) {
             headers = headers.set('Authorization', String(authorization));
         }

         // authentication (authtoken) required
         if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
             headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
         }

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.get<Array<CustomEntityFull>>(`${this.basePath}/customentity/company/${encodeURIComponent(String(idcompany))}`,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     * Get list of customEntity
     *
     * @param authorization Access token in the format Bearer token
     * @param tipo Get entities of a type id
     * @param history Get also elements from snapshots (only for managers)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public customEntitieslist(authorization?: string, tipo?: string, history?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<CustomEntity>>;
     public customEntitieslist(authorization?: string, tipo?: string, history?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CustomEntity>>>;
     public customEntitieslist(authorization?: string, tipo?: string, history?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CustomEntity>>>;
     public customEntitieslist(authorization?: string, tipo?: string, history?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (tipo !== undefined && tipo !== null) {
             queryParameters = queryParameters.set('tipo', <any>tipo);
         }
         if (history !== undefined && history !== null) {
             queryParameters = queryParameters.set('history', <any>history);
         }

         let headers = this.defaultHeaders;
         if (authorization !== undefined && authorization !== null) {
             headers = headers.set('Authorization', String(authorization));
         }

         // authentication (authtoken) required
         if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
             headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
         }

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.get<Array<CustomEntity>>(`${this.basePath}/customentity`,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     * Delete CustomElement
     *
     * @param id CustomElement Id to delete
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deletecustomelement(id: string, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<CustomElement>;
    public deletecustomelement(id: string, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomElement>>;
    public deletecustomelement(id: string, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomElement>>;
    public deletecustomelement(id: string, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deletecustomelement.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<CustomElement>(`${this.basePath}/customElement/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete CustomEntity
     *
     * @param idcustomentity CustomEntity Id to delete
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deletecustomentity(idcustomentity: string, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<CustomEntity>;
    public deletecustomentity(idcustomentity: string, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomEntity>>;
    public deletecustomentity(idcustomentity: string, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomEntity>>;
    public deletecustomentity(idcustomentity: string, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idcustomentity === null || idcustomentity === undefined) {
            throw new Error('Required parameter idcustomentity was null or undefined when calling deletecustomentity.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<CustomEntity>(`${this.basePath}/customentity/${encodeURIComponent(String(idcustomentity))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get CustomElement joins
     *
     * @param idelement CustomElement Id to get joins from
     * @param idcompany IdCompany to get joins from
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public getcustomelementjoins(idelement: string, idcompany: number, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<CustomElementJoins>;
     public getcustomelementjoins(idelement: string, idcompany: number, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomElementJoins>>;
     public getcustomelementjoins(idelement: string, idcompany: number, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomElementJoins>>;
     public getcustomelementjoins(idelement: string, idcompany: number, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (idelement === null || idelement === undefined) {
             throw new Error('Required parameter idelement was null or undefined when calling getcustomelementjoins.');
         }

         if (idcompany === null || idcompany === undefined) {
             throw new Error('Required parameter idcompany was null or undefined when calling getcustomelementjoins.');
         }


         let headers = this.defaultHeaders;
         if (authorization !== undefined && authorization !== null) {
             headers = headers.set('Authorization', String(authorization));
         }

         // authentication (authtoken) required
         if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
             headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
         }

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.get<CustomElementJoins>(`${this.basePath}/customelement/${encodeURIComponent(String(idcompany))}/${encodeURIComponent(String(idelement))}/joins`,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     * Get a single customentity
     *
     * @param idcustomentity CustomEntity Id to get
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getcustomentity(idcustomentity: string, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<CustomEntity>;
    public getcustomentity(idcustomentity: string, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomEntity>>;
    public getcustomentity(idcustomentity: string, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomEntity>>;
    public getcustomentity(idcustomentity: string, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idcustomentity === null || idcustomentity === undefined) {
            throw new Error('Required parameter idcustomentity was null or undefined when calling getcustomentity.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CustomEntity>(`${this.basePath}/customentity/${encodeURIComponent(String(idcustomentity))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update customForm
     *
     * @param id CustomElement Id to edit
     * @param customelement CustomElement to update
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatecustomelement(id: string, customelement: CustomElement, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CustomElement>>;
    public updatecustomelement(id: string, customelement: CustomElement, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CustomElement>>>;
    public updatecustomelement(id: string, customelement: CustomElement, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CustomElement>>>;
    public updatecustomelement(id: string, customelement: CustomElement, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updatecustomelement.');
        }

        if (customelement === null || customelement === undefined) {
            throw new Error('Required parameter customelement was null or undefined when calling updatecustomelement.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Array<CustomElement>>(`${this.basePath}/customElement/${encodeURIComponent(String(id))}`,
            customelement,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update customEntityJoins
     *
     * @param idelement CustomEntityJoins Id to edit
     * @param idcompany IdCompany to get customentity&#39;s joins from
     * @param customelementjoin CustomEntityJoins to update
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public updatecustomelementjoins(idelement: string, idcompany: number, customelementjoin: CustomEntityJoin, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<CustomEntityJoin>;
     public updatecustomelementjoins(idelement: string, idcompany: number, customelementjoin: CustomEntityJoin, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomEntityJoin>>;
     public updatecustomelementjoins(idelement: string, idcompany: number, customelementjoin: CustomEntityJoin, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomEntityJoin>>;
     public updatecustomelementjoins(idelement: string, idcompany: number, customelementjoin: CustomEntityJoin, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (idelement === null || idelement === undefined) {
             throw new Error('Required parameter idelement was null or undefined when calling updatecustomelementjoins.');
         }

         if (idcompany === null || idcompany === undefined) {
             throw new Error('Required parameter idcompany was null or undefined when calling updatecustomelementjoins.');
         }

         if (customelementjoin === null || customelementjoin === undefined) {
             throw new Error('Required parameter customelementjoin was null or undefined when calling updatecustomelementjoins.');
         }


         let headers = this.defaultHeaders;
         if (authorization !== undefined && authorization !== null) {
             headers = headers.set('Authorization', String(authorization));
         }

         // authentication (authtoken) required
         if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
             headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
         }

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected != undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.put<CustomEntityJoin>(`${this.basePath}/customelement/${encodeURIComponent(String(idcompany))}/${encodeURIComponent(String(idelement))}/joins`,
             customelementjoin,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     * Update customEntityRestore
     *
     * @param idelement CustomEntityRestore Id to edit
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatecustomelementrestore(idelement: string, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CustomEntity>>;
    public updatecustomelementrestore(idelement: string, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CustomEntity>>>;
    public updatecustomelementrestore(idelement: string, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CustomEntity>>>;
    public updatecustomelementrestore(idelement: string, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idelement === null || idelement === undefined) {
            throw new Error('Required parameter idelement was null or undefined when calling updatecustomelementrestore.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<Array<CustomEntity>>(`${this.basePath}/customelement/${encodeURIComponent(String(idelement))}/restore`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update customEntityUnhide
     *
     * @param idelement CustomEntityUnhide Id to edit
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public updatecustomelementunhide(idelement: string, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CustomEntity>>;
     public updatecustomelementunhide(idelement: string, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CustomEntity>>>;
     public updatecustomelementunhide(idelement: string, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CustomEntity>>>;
     public updatecustomelementunhide(idelement: string, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (idelement === null || idelement === undefined) {
             throw new Error('Required parameter idelement was null or undefined when calling updatecustomelementunhide.');
         }

         let headers = this.defaultHeaders;
         if (authorization !== undefined && authorization !== null) {
             headers = headers.set('Authorization', String(authorization));
         }

         // authentication (authtoken) required
         if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
             headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
         }

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.put<Array<CustomEntity>>(`${this.basePath}/customelement/${encodeURIComponent(String(idelement))}/unhide`,
             null,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     * Update customEntityHide (archivar elemento)
     *
     * @param idelement CustomEntityUnhide Id to edit
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public updatecustomelementhide(idelement: string, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CustomEntity>>;
     public updatecustomelementhide(idelement: string, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CustomEntity>>>;
     public updatecustomelementhide(idelement: string, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CustomEntity>>>;
     public updatecustomelementhide(idelement: string, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (idelement === null || idelement === undefined) {
             throw new Error('Required parameter idelement was null or undefined when calling updatecustomelementhide.');
         }

         let headers = this.defaultHeaders;
         if (authorization !== undefined && authorization !== null) {
             headers = headers.set('Authorization', String(authorization));
         }

         // authentication (authtoken) required
         if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
             headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
         }

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.put<Array<CustomEntity>>(`${this.basePath}/customelement/${encodeURIComponent(String(idelement))}?archived=true`,
             null,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     * Update customEntity
     *
     * @param idcustomentity CustomEntity Id to edit
     * @param customentity CustomEntity to update
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatecustomentity(idcustomentity: string, customentity: CustomEntity, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CustomEntity>>;
    public updatecustomentity(idcustomentity: string, customentity: CustomEntity, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CustomEntity>>>;
    public updatecustomentity(idcustomentity: string, customentity: CustomEntity, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CustomEntity>>>;
    public updatecustomentity(idcustomentity: string, customentity: CustomEntity, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idcustomentity === null || idcustomentity === undefined) {
            throw new Error('Required parameter idcustomentity was null or undefined when calling updatecustomentity.');
        }

        if (customentity === null || customentity === undefined) {
            throw new Error('Required parameter customentity was null or undefined when calling updatecustomentity.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Array<CustomEntity>>(`${this.basePath}/customentity/${encodeURIComponent(String(idcustomentity))}`,
            customentity,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

     /**
     * Get list of customEntity&#39;s types
     *
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
      public customEntityTypeslist(authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CustomType>>;
      public customEntityTypeslist(authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CustomType>>>;
      public customEntityTypeslist(authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CustomType>>>;
      public customEntityTypeslist(authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


          let headers = this.defaultHeaders;
          if (authorization !== undefined && authorization !== null) {
              headers = headers.set('Authorization', String(authorization));
          }

          // authentication (authtoken) required
          if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
              headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
          }

          // to determine the Accept header
          let httpHeaderAccepts: string[] = [
              'application/json'
          ];
          const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
          if (httpHeaderAcceptSelected != undefined) {
              headers = headers.set('Accept', httpHeaderAcceptSelected);
          }

          // to determine the Content-Type header
          const consumes: string[] = [
          ];

          return this.httpClient.get<Array<CustomType>>(`${this.basePath}/customentitytypes`,
              {
                  withCredentials: this.configuration.withCredentials,
                  headers: headers,
                  observe: observe,
                  reportProgress: reportProgress
              }
          );
      }

       /**
     * Create snapshot from element
     *
     * @param idelement CustomElement Id to snapshot
     * @param limits Límites temporales del snapshot
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public snapshotelement(idelement: string, limits: SnapshotLimits, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<CustomElementSnapshot>;
    public snapshotelement(idelement: string, limits: SnapshotLimits, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomElementSnapshot>>;
    public snapshotelement(idelement: string, limits: SnapshotLimits, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomElementSnapshot>>;
    public snapshotelement(idelement: string, limits: SnapshotLimits, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idelement === null || idelement === undefined) {
            throw new Error('Required parameter idelement was null or undefined when calling snapshotelement.');
        }

        if (limits === null || limits === undefined) {
            throw new Error('Required parameter limits was null or undefined when calling snapshotelement.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CustomElementSnapshot>(`${this.basePath}/customelement/${encodeURIComponent(String(idelement))}/history`,
            limits,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
